/* eslint-disable react/no-unknown-property */
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const videoTypes = {
  wistia: 'https://fast.wistia.com/embed/iframe/',
  youtube: 'https://www.youtube.com/embed/',
};

const VideoEmbed = ({ className, embedId, embedType, videoWidth, videoHeight }) => (
  <figure className={clsx('relative h-0 w-full overflow-hidden pb-[56.25%]', className)}>
    <iframe
      className="absolute top-0 left-0 h-full w-full rounded-[10px] border-none"
      src={`${videoTypes[embedType]}${embedId}`}
      allowtransparency="true"
      frameBorder="0"
      name={`${videoTypes[embedType]}_embed`}
      title={`Embedded ${videoTypes[embedType]}`}
      width={videoWidth}
      height={videoHeight}
      allowFullScreen
    />
  </figure>
);

VideoEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
  embedType: PropTypes.string.isRequired,
  videoWidth: PropTypes.number.isRequired,
  videoHeight: PropTypes.number.isRequired,
  className: PropTypes.string,
};

VideoEmbed.defaultProps = {
  className: null,
};

export default VideoEmbed;
